module.exports = __webpack_public_path__ + "img/heart-white-fill.6c9b0809.svg";